export default "__VITE_ASSET__D8I_Okrz__"